/* All my Blue — short silent clips inside Journal posts (~1 KB)
   A clip in the text is <video class="amb-clip" muted loop playsinline preload="none" poster="…">.
   Nothing downloads until the clip is about to come into view; then it plays, and it
   pauses again when it leaves the screen. With reduced motion it never starts by itself:
   the still frame stays and the visitor gets the play button. If the phone blocks
   autoplay (an iPhone in Low Power Mode), the play button appears too. */
(function () {
  var clips = document.querySelectorAll('video.amb-clip, .blog-post-content video');
  if (!clips.length) return;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function prep(v) {
    v.muted = true;
    v.setAttribute('playsinline', '');
    if (reduce) v.controls = true;
  }
  function play(v) {
    var p = v.play();
    if (p && p.catch) p.catch(function () { v.controls = true; });
  }
  for (var i = 0; i < clips.length; i++) prep(clips[i]);
  if (reduce) return;
  if (!('IntersectionObserver' in window)) {
    for (var j = 0; j < clips.length; j++) play(clips[j]);
    return;
  }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      var v = e.target;
      if (e.isIntersecting) { if (v.paused && !v.controls) play(v); }
      else if (!v.paused && !v.controls) v.pause();
    });
  }, { rootMargin: '200px 0px' });
  for (var k = 0; k < clips.length; k++) io.observe(clips[k]);
})();
